import {useState, useEffect} from 'react';
import {getEmployeeDashboardPeriod} from './business/dashboardBusiness';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {EMenuId} from '../../const/dataEnum';
import {getPathByMenuId} from '../../stores/business/appBusiness';
import DashboardCardLayout from '../../components/DashboardCardLayout';
import {formatPeriodDate} from '../../lib/dateTimesHelpers';
import {statusTranslator} from '../../lib/utilities';

const EmployeDashboardInfo = ({periods, currentPeriod}) => {
  const reduxDispatch = useDispatch();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState({
    taskDone: 0,
    totalTask: 0,
    consolidationStatus: 0,
  });

  useEffect(() => {
    (async () => {
      setIsLoading(true); // start loading

      try {
        const result = await reduxDispatch(getEmployeeDashboardPeriod(currentPeriod));
        if (result) {
          setData({
            ...result,
            consolidationStatus: statusTranslator(result.consolidationStatus),
          });
        }
      } finally {
        setIsLoading(false); // stop loading regardless of success or failure
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPeriod]);
  
  const handleClickGoToPage = (page) => {
    const path = getPathByMenuId(page);
    if (path) {
      history.push(path);
    }
  };

  const employeCardContent = [
    {
      dataFormated: `${formatPeriodDate(periods)}`,
      heading: 'Active Review Period',
    },
    {
      dataFormated: `${data.taskDone} / ${data.totalTask}`,
      heading: 'Task Review',
      actions: [
        {
          label: 'Go to task review',
          onClick: () => handleClickGoToPage(EMenuId.REVIEW_TASK),
        },
      ],
    },
    {
      dataFormated: `${data?.consolidationStatus}`,
      heading: 'Consolidation Status',
      actions: [
        {
          label: 'Go to consolidated Review',
          onClick: () => handleClickGoToPage(EMenuId.CONSOLIDATED_REVIEW),
        },
      ],
    },
  ];

  return (
    <DashboardCardLayout
      className={'dashboard-info'}
      cardClassName={'dashboard-card'}
      col={3}
      row={1}
      content={employeCardContent}
      loading={isLoading}
    />
  );
};

export default EmployeDashboardInfo;
